(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('OrganizationDetailsController', OrganizationDetailsController);

  /** @ngInject */
  function OrganizationDetailsController(
    OrganizationDetailsViewModel,
    OrganizationViewModel,
    $scope,
    $state,
    $stateParams,
    $mdToast,
    $log,
    $translate,
    layoutActions,
    organizationActions,
    userActions,
    dashboardKarcherActions,
    brand
  ) {
    var vm = this;
    var organizationParentType = '';
    var originalVoucherExpirationDays = null; // Čuva originalnu vrednost iz baze
    var originalRolloverVoucherExpirationDays = null; // Čuva originalnu vrednost iz baze
    var originalSavingsExpirationDays = null; // Čuva originalnu vrednost iz baze
    var currentCompanyId = null; // Čuva company ID za update

    vm.organizationDetails = new OrganizationDetailsViewModel();
    vm.isEditMode = !($stateParams.create === 'true');
    vm.brand = brand;

    init();

    vm.createOrganization = function () {
      var data = {
        name: vm.organizationDetails.organizationName,
        address: vm.organizationDetails.organizationAddress,
        type: vm.organizationDetails.organizationType,
        voucherExpirationDays: vm.organizationDetails.voucherExpirationDays
      };

      if (vm.organizationDetails.supportedOrganization) {
        data.support = {
          id: parseInt(vm.organizationDetails.supportedOrganization),
          type: vm.organizationDetails.supportedOrganizationType
        };
      }

      if (!vm.isEditMode) {
        data.parent = {
          id: parseInt($stateParams.id),
          type: organizationParentType
        };
        switch (vm.organizationDetails.organizationType) {
          case 'COMPANY':
            data.company = vm.organizationDetails.typeSelector;
            break;
          case 'REGION':
            data.region = vm.organizationDetails.typeSelector;
            break;
          case 'SITE':
            data.sitePointId = vm.organizationDetails.typeSelector;
            break;
        }
      } else {
        data.id = parseInt($stateParams.id);
      }

      if (!vm.isEditMode) {
        organizationActions.createChildOrganization(data).then(function () {});
      } else {
        // Edit mode - prvo update organizacije
        organizationActions
          .updateChildOrganization(data)
          .then(function () {
            // Proveri da li je promenjena vrednost voucherExpirationDays za COMPANY tip
            if (vm.organizationDetails.organizationType === 'COMPANY' && 
                currentCompanyId && 
                originalVoucherExpirationDays !== null) {
              
              var newValue = parseInt(vm.organizationDetails.voucherExpirationDays);
              var newRolloverValue = parseInt(vm.organizationDetails.rolloverVoucherExpirationDays);
              var newSavingsValue = parseInt(vm.organizationDetails.savingsExpirationDays);
              
              // Ako se vrednost promenila, pozovi update
              if (originalVoucherExpirationDays !== newValue) {
                organizationActions.updateOrganizationVoucherExpirationDays(
                  currentCompanyId, 
                  newValue
                );
              }
              
              // Ako se rollover vrednost promenila, pozovi update
              if (originalRolloverVoucherExpirationDays !== newRolloverValue) {
                organizationActions.updateOrganizationRolloverVoucherExpirationDays(
                  currentCompanyId, 
                  newRolloverValue
                );
              }
              
              // Ako se savings vrednost promenila, pozovi update
              if (originalSavingsExpirationDays !== newSavingsValue) {
                organizationActions.updateOrganizationSavingsExpirationDays(
                  currentCompanyId, 
                  newSavingsValue
                );
              }
            }
          });
      }
    };

    vm.clearInput = function () {
      vm.organizationDetails.supportedOrganization = '';
      vm.organizationDetails.supportedOrganizationType = '';
      $scope.createOrganizationForm.$setDirty();
    };

    vm.selectOrganizationType = function () {
      createOrganizationTypeList();
    };
    vm.selectSupportedOrganization = function () {
      mapSupportedOrganizationType();
    };

    vm.getSelectedValue = function (ids) {
      vm.organizationDetails.typeSelector = ids;
    };

    vm.clearSelectorInput = function () {
      vm.organizationDetails.typeSelector = '';
    };

    function createOrganizationTypeList() {
      layoutActions.showLoader();
      vm.organizationDetails.hideSelectorList = true;
      vm.organizationDetails.placeHolderText =
        $translate.instant('SELECT_ORGANIZATION_SELECTOR') + " " +
        vm.organizationDetails.organizationType.toLowerCase();
      switch (vm.organizationDetails.organizationType) {
        case 'COMPANY':
          getCompanyList();
          break;
        case 'REGION':
          getRegionList();
          break;
        case 'SITE':
          getSiteList();
          break;
        default:
          vm.organizationDetails.hideSelectorList = false;
          vm.organizationDetails.typeSelector = '-';
          layoutActions.hideLoader();
          return;
      }
    }

    function getCompanyList() {
      if (vm.isEditMode) {
        organizationActions
          .getOrganizationsCompanyById(vm.organizationDetails.typeSelector)
          .then(function (companyDetails) {
            vm.organizationDetails.organizationTypeSelectorInEditMode = companyDetails.name;
            vm.organizationDetails.voucherExpirationDays = companyDetails.voucherExpirationDays || '';
            vm.organizationDetails.rolloverVoucherExpirationDays = companyDetails.rolloverVoucherExpirationDays || 90;
            vm.organizationDetails.savingsExpirationDays = companyDetails.savingsExpirationDays || 365;
            // Čuvaj originalnu vrednost i company ID za proveru prilikom čuvanja
            originalVoucherExpirationDays = companyDetails.voucherExpirationDays;
            originalRolloverVoucherExpirationDays = companyDetails.rolloverVoucherExpirationDays;
            originalSavingsExpirationDays = companyDetails.savingsExpirationDays;
            currentCompanyId = companyDetails.id;
          });
      } else {
        vm.organizationDetails.typeSelectorList = [];
        organizationActions
          .getAllCompaniesShort($stateParams.id)
          .then(function (res) {
            vm.organizationDetails.refreshTypeSelectorList(res);
            layoutActions.hideLoader();
          });
      }
    }

    function getRegionList() {
      if (vm.isEditMode) {
        userActions
          .getRegionById(vm.organizationDetails.typeSelector)
          .then(function (regionDetails) {
            vm.organizationDetails.organizationTypeSelectorInEditMode = regionDetails.name;
          });
      } else {
        vm.organizationDetails.typeSelectorList = [];
        organizationActions.getAllRegionsShort().then(function(res) {
          vm.organizationDetails.refreshTypeSelectorList(res);
          layoutActions.hideLoader();
        });
      }
    }

    function getSiteList() {
      if (vm.isEditMode) {
        dashboardKarcherActions
          .getKarcherSitesInfoWindowData(vm.organizationDetails.typeSelector)
          .then(function (siteDetails) {
            vm.organizationDetails.organizationTypeSelectorInEditMode = siteDetails.site.name;
          });
      } else {
        vm.organizationDetails.typeSelectorList = [];
        organizationActions
          .getAllSitesShort($stateParams.id)
          .then(function(res) {
            vm.organizationDetails.refreshTypeSelectorList(res);
            layoutActions.hideLoader();
          });
      }
    }

    function mapSupportedOrganizationType() {
      vm.organizationDetails.organizationList.forEach(function (org) {
        if (parseInt(vm.organizationDetails.supportedOrganization) === org.id) {
          vm.organizationDetails.supportedOrganizationType = org.type;
        }
      });
      createOrganizationTypeList();
      layoutActions.hideLoader();
    }

    function init() {
      $scope.$on('$destroy', destroy);
      layoutActions.showLoader();

      organizationActions
        .getSupportedOrganizationList($stateParams.id)
        .then(function (res) {
          vm.organizationDetails.refreshOrganizationList(res);
          organizationActions
            .getOrganizationById($stateParams.id)
            .then(function (organizationData) {
              organizationParentType = organizationData.type;
              if (vm.isEditMode) {
                vm.organizationDetails.organizationName = organizationData.name;
                vm.organizationDetails.organizationType = organizationData.type;
                vm.organizationDetails.supportedOrganization =
                  organizationData.support ? organizationData.support.id : '';
                vm.organizationDetails.organizationAddress =
                  organizationData.address;
                vm.organizationDetails.voucherExpirationDays =
                  organizationData.voucherExpirationDays || '';
                vm.organizationDetails.rolloverVoucherExpirationDays =
                  organizationData.rolloverVoucherExpirationDays || 90;
                vm.organizationDetails.savingsExpirationDays =
                  organizationData.savingsExpirationDays || 365;
                switch (organizationData.type) {
                  case 'COMPANY':
                    vm.organizationDetails.typeSelector =
                      organizationData.company;
                    break;
                  case 'REGION':
                    vm.organizationDetails.typeSelector =
                      organizationData.region;
                    break;
                  case 'SITE':
                    vm.organizationDetails.typeSelector =
                      organizationData.sitePointId;
                    break;
                  default:
                    vm.organizationDetails.typeSelector = '-';
                }
                mapSupportedOrganizationType();
              } else {
                vm.organizationDetails.parentOrganizationName =
                  organizationData.name;
                layoutActions.hideLoader();
              }
            });
        });
    }

    function destroy() {
      vm.organizationDetails.destroy();
    }
  }
})();
